import jQuery from 'jquery';

const $ = jQuery;

$(document).ready(function() {
    console.log('form.js cargado, inicializando manejo del formulario');

    $('#contactForm').on('submit', function(e) {
        e.preventDefault();
        const form = $(this);
        const formData = form.serialize();
        const messages = $('#formMessages');

        // Limpiar mensajes anteriores
        messages.empty();
        $('.error-message').empty();
        $('.form-control, .form-check-input').removeClass('is-invalid');

        $.ajax({
            url: window.formSubmitUrl,
            type: 'POST',
            data: formData,
            success: function(response) {
                if (response.success) {
                    messages.html('<div class="alert alert-success">' + response.message + '</div>');
                    form[0].reset();
                }
            },
            error: function(xhr) {
                if (xhr.status === 422) {
                    const errors = xhr.responseJSON.errors;
                    console.log('Errores de validación:', errors); // Depuración

                    $.each(errors, function(field, messages) {
                        const errorElement = $('#' + field + '-error');
                        if (errorElement.length) { // Verificar que el elemento exista
                            errorElement.html(messages.join('<br>'));
                            $('[name="' + field + '"]').addClass('is-invalid');
                        }
                    });

                    messages.html('<div class="alert alert-danger">Por favor, corrige los errores en el formulario.</div>');
                } else {
                    messages.html('<div class="alert alert-danger">Ocurrió un error. Por favor, intenta de nuevo.</div>');
                }
            }
        });
    });




});


